'use client'
import React from 'react';
import { Link } from 'react-router-dom'; // Use react-router-dom for routing.
import { useState } from 'react';
import ServiceDetailsImg from '../../assets/images/services/MAGNET.png'
import ServiceDetailsImg1 from '../../assets/images/services/GRAB.png'
import ServiceDetailsImg2 from '../../assets/images/services/service-details-images-1-2.jpg'
import { Swiper, SwiperSlide } from 'swiper/react';
import ImageGallery from "react-image-gallery";
import 'react-image-gallery/styles/css/image-gallery.css';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import table, { Table } from 'react-bootstrap'
import SEOHelmet from '../../components/SEO/SEOHelmet';
// import ModalVideo from 'react-modal-video';
// import 'react-modal-video/css/modal-video.min.css';
const mainSlider = {
    width: '90%',
}
const Grabber = () => {
    const images = [
        {
            original: ServiceDetailsImg1,
            thumbnail: ServiceDetailsImg1,
            originalAlt: "Slide 1",
            thumbnailAlt: "Thumbnail 1",
        },
        // { 410X361px
        //     original: ServiceDetailsImg2,
        //     thumbnail: ServiceDetailsImg2,
        //     originalAlt: "Slide 2",
        //     thumbnailAlt: "Thumbnail 2",
        // }

    ]
    // State to hold dynamic content
    const [projectInfo] = useState({
        category: "Roof Service",
        customer: "David Bravis",
        startDate: "21 April 2024",
        endDate: "28 September 2024",
        rating: 5,
    });
    const [socialLinks] = useState([
        { href: "https://www.facebook.com/profile.php?id=61573443062800", iconClass: "icon-facebook-f" },
        { href: "https://x.com/design79356", iconClass: "icon-Vector" },
        { href: "https://www.instagram.com/ramanasteels/", iconClass: "icon-instagram" },
        { href: "https://in.pinterest.com/Ramanasteels/", iconClass: "icon-pinterest" },
    ]);
    const [serviceDetails] = useState({


        image1: ServiceDetailsImg,

        title: "Scrap Grabber",
        text2: "A scrap grabber, also known as a scrap metal grabber or a hydraulic grabber, is a specialized attachment for heavy machinery that is designed to pick up and transport large amounts of scrap metal. The grabber is typically attached to a crane, excavator, or other heavy equipment and is operated by the machinery's hydraulic system.Scrap grabbers come in a variety of sizes and styles, with some designed for use in specific industries or applications. The grabber is made up of four & six arms that are connected to a hydraulic system, which allows them to open and close and pick up the scrap metal.",

    });

    return (
        <React.Fragment>
            <SEOHelmet 
                title="Efficient Scrap Grabber for Material Handling"
                description="High-capacity scrap grabber with multiple jaw options for picking up and transporting large amounts of scrap metal efficiently."
                keywords="scrap grabber, metal grabber, hydraulic grabber, material handling, scrap handling"
                canonicalUrl="https://ramanasteels.com/grabber"
            />
            {/* Service Details Start */}
            <section className="service-details">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8 col-lg-7">
                            <div className="service-details__left">
                                <div className="service-details__content-one">

                                    <p className="service-details__text-1">{serviceDetails.text1}</p>
                                    <div className="justify-content-center mt-4">
                                        <div className="card p-3 rounded" style={mainSlider}>
                                            <ImageGallery
                                                items={images}
                                                showPlayButton={false}
                                                showFullscreenButton={true}
                                                showThumbnails={true}
                                                autoPlay={true}
                                                slideInterval={4000}
                                                showNav={true}
                                                additionalClass="img-slider"
                                            />
                                        </div>
                                    </div>
                                    <h1 className="service-details__title-one">{serviceDetails.title}</h1>
                                </div>
                                <div className="service-details__content-two">
                                    <h4 className="service-details__title-two">{serviceDetails.title2}</h4>
                                    <p className="service-details__text-2">{serviceDetails.text2}</p>
                                    {/* <ul className="list-unstyled service-details__points">
                                        <h3>Features</h3>
                                        {serviceDetails.points.map((point, index) => (
                                            <li key={index}>
                                                <div className="icon">
                                                    <i className="far fa-check" />
                                                </div>
                                                <div className="text">
                                                    <p>{point}</p>
                                                </div>
                                            </li>
                                        ))}
                                    </ul> */}
                                </div>
                                <div>
                                    <Table responsive>
                                        <thead style={{ color: '#FFFFFF', background: '#2F8CD6' }}><tr> <th>VOLUMETRIC CAPACITY  </th>
                                            <th>NO OF JAW</th>
                                            <th>DENSITY OF THE STEEL SCRAP IS TO HANDLE</th>
                                            <th>CONTROL </th>

                                        </tr></thead>
                                        <tbody>
                                            <tr>
                                                <td>0.5 to 3.5 mtr<sup>3</sup></td>
                                                <td>4 or 6</td>
                                                <td>1500 kg to 5 Ton</td>
                                                <td>On Operator Panel</td>

                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-5">
                            <div className="project-details__sidebar">
                                <div className="project-details__project-info">
                                    <h3 className="project-details__project-info-title">
                                        Product Information
                                    </h3>
                                    <ul className="list-unstyled project-details__project-info-list">
                                        <li>
                                            <h5>Origin:</h5>
                                            <h5>China{/* {projectInfo.category} */}</h5>
                                        </li>
                                        <li>
                                            <h5>Make:</h5>
                                            <h5>Gaode{/* {projectInfo.customer} */}</h5>
                                        </li>
                                        <li>
                                            <h5>Used In:</h5>
                                            <h5> Heavy duty scrap<br /> processing{/* {projectInfo.startDate} */}</h5>
                                        </li>
                                        <li>
                                            <h5>Rating:</h5>
                                            <div className="rating">
                                                {Array(projectInfo.rating)
                                                    .fill(0)
                                                    .map((_, index) => (
                                                        <span className="icon-star" key={index}></span>
                                                    ))}
                                            </div>
                                        </li>
                                    </ul>
                                    <div className="project-details__social">
                                        {socialLinks.map((link, index) => (
                                            <Link to={link.href} key={index}>
                                                <span className={link.iconClass}></span>
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="project-details__need-help">
                                {/* <div className="project-details__need-help-img">
                                    <img
                                        src="/assets/images/project/project-details-need-help-img.jpg"
                                        alt="Need Help"
                                    />
                                </div> */}
                                <div className="project-details__need-help-icon">
                                    <span className="icon-call"></span>
                                </div>
                                <p className="project-details__need-help-sub-title">
                                    Contact Us
                                </p>
                                <h3 className="project-details__need-help-number">
                                    <Link to="tel:+91-9815902561"> +91-9815902561</Link>
                                </h3>
                            </div>
                            {/* <div className="project-details__download">
                                <ul className="project-details__download-list list-unstyled">
                                    <li>
                                        <Link to="#">
                                            <span>Company File</span>
                                            <p>
                                                (1.5Mb)
                                                <i className="icon-download"></i>
                                            </p>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#">
                                            <span>Project File</span>
                                            <p>
                                                (1.5Mb)
                                                <i className="icon-download"></i>
                                            </p>
                                        </Link>
                                    </li>
                                </ul>
                            </div> */}
                        </div>

                    </div>
                </div>
            </section>
            {/* Service Details End */}
        </React.Fragment>
    );
};

export default Grabber;


